
// src/pages/Home.js
import React,{ useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import Header from '@/components/Header';
import Section from '@/components/Section';
import BookShelf from '@/components/BookShelf';
import Scifi from '@/scifi.json'
import Romance from '@/romance.json'
import Biography from '@/bio.json'
import Business from '@/business.json'
import Fiction from '@/fiction.json'
import ErrorDisplay from '@/components/ErrorDisplay';


const Home = () => {
  const [popularBooks, setPopularBooks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // const fetchPopularBooks = async () => {
    //   try {
    //     const data = await getPopularBooks();
    //     setPopularBooks(data);
    //     setIsLoading(false);
    //   } catch (err) {
    //     setError(err);
    //     setIsLoading(false);
    //   }
    // };

    // fetchPopularBooks();
  }, []);

  // if (isLoading) return <div>Loading...</div>;
  // if (error) return <ErrorDisplay error={error} />;

  return (
    <div className='mb-60'>
      <Header />
      <div className="container mt-10 flex-1 md:w-[800px] lg:w-[800px]">
        <div className=" md:pt-28 md:pb-14">
          <Section />
        </div>
      </div>

      {Scifi && <BookShelf title="Science fiction" books={Scifi} marginLeft="40px" />}
      {Business && <BookShelf title="Business" books={Business} marginLeft="-170px"/>}
      {Romance && <BookShelf title="Romance" books={Romance} marginLeft="40px" />}
      {Fiction && <BookShelf title="Fiction" books={Fiction} marginLeft="-170px"/>}
      {Biography && <BookShelf title="Biography" books={Biography} marginLeft="40px"/>}

    </div>
  );
};

export default Home;